import script from "./FooterCalendar.vue?vue&type=script&setup=true&lang=js"
export * from "./FooterCalendar.vue?vue&type=script&setup=true&lang=js"

import "./FooterCalendar.vue?vue&type=style&index=0&id=4066f70b&lang=css"

const __exports__ = script;

export default __exports__